var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsDual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7091 11.2122C7.16933 11.2114 7.54171 10.8375 7.54083 10.3773C7.53994 9.91708 7.16613 9.5447 6.70589 9.54559C6.24565 9.54647 5.87328 9.92028 5.87416 10.3805C5.87505 10.8408 6.24886 11.2131 6.7091 11.2122Z",
    fill: "#F7F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69787 5.37893C7.1581 5.37804 7.53048 5.00423 7.5296 4.54399C7.52871 4.08375 7.1549 3.71138 6.69466 3.71226C6.23442 3.71315 5.86205 4.08696 5.86293 4.5472C5.86382 5.00744 6.23763 5.37981 6.69787 5.37893Z",
    fill: "#F7F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72033 17.0456C7.18056 17.0447 7.55294 16.6709 7.55205 16.2106C7.55117 15.7504 7.17736 15.378 6.71712 15.3789C6.25688 15.3798 5.88451 15.7536 5.88539 16.2138C5.88628 16.6741 6.26009 17.0465 6.72033 17.0456Z",
    fill: "#F7F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7091 11.2122C7.16933 11.2114 7.54171 10.8375 7.54083 10.3773C7.53994 9.91708 7.16613 9.5447 6.70589 9.54559C6.24565 9.54647 5.87328 9.92028 5.87416 10.3805C5.87505 10.8408 6.24886 11.2131 6.7091 11.2122Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69787 5.37893C7.1581 5.37804 7.53048 5.00423 7.5296 4.54399C7.52871 4.08375 7.1549 3.71138 6.69466 3.71226C6.23442 3.71315 5.86205 4.08696 5.86293 4.5472C5.86382 5.00744 6.23763 5.37981 6.69787 5.37893Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72033 17.0456C7.18056 17.0447 7.55294 16.6709 7.55205 16.2106C7.55117 15.7504 7.17736 15.378 6.71712 15.3789C6.25688 15.3798 5.88451 15.7536 5.88539 16.2138C5.88628 16.6741 6.26009 17.0465 6.72033 17.0456Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3751 11.1996C13.8354 11.1987 14.2077 10.8249 14.2068 10.3646C14.206 9.90438 13.8321 9.532 13.3719 9.53289C12.9117 9.53378 12.5393 9.90759 12.5402 10.3678C12.5411 10.8281 12.9149 11.2004 13.3751 11.1996Z",
    fill: "#F7F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3639 5.36623C13.8241 5.36535 14.1965 4.99153 14.1956 4.5313C14.1947 4.07106 13.8209 3.69868 13.3607 3.69957C12.9004 3.70045 12.5281 4.07427 12.5289 4.5345C12.5298 4.99474 12.9036 5.36712 13.3639 5.36623Z",
    fill: "#F7F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3863 17.0329C13.8466 17.032 14.219 16.6582 14.2181 16.1979C14.2172 15.7377 13.8434 15.3653 13.3831 15.3662C12.9229 15.3671 12.5505 15.7409 12.5514 16.2011C12.5523 16.6614 12.9261 17.0338 13.3863 17.0329Z",
    fill: "#F7F9F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3751 11.1996C13.8354 11.1987 14.2077 10.8249 14.2068 10.3646C14.206 9.90438 13.8321 9.532 13.3719 9.53289C12.9117 9.53378 12.5393 9.90759 12.5402 10.3678C12.5411 10.8281 12.9149 11.2004 13.3751 11.1996Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3639 5.36623C13.8241 5.36535 14.1965 4.99153 14.1956 4.5313C14.1947 4.07106 13.8209 3.69868 13.3607 3.69957C12.9004 3.70045 12.5281 4.07427 12.5289 4.5345C12.5298 4.99474 12.9036 5.36712 13.3639 5.36623Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3863 17.0329C13.8466 17.032 14.219 16.6582 14.2181 16.1979C14.2172 15.7377 13.8434 15.3653 13.3831 15.3662C12.9229 15.3671 12.5505 15.7409 12.5514 16.2011C12.5523 16.6614 12.9261 17.0338 13.3863 17.0329Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsDual);
export default __webpack_public_path__ + "static/media/dots-dual.78ac11c1e31479655668cad5e8722d7d.svg";
export { ForwardRef as ReactComponent };